/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Improve_Deliverable_ValueInputs */

const en_how_we_work_improve_deliverable_value = /** @type {(inputs: How_We_Work_Improve_Deliverable_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An agreed scope for maintenance and improvement.`)
};

const lv_how_we_work_improve_deliverable_value = /** @type {(inputs: How_We_Work_Improve_Deliverable_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saskaņots uzturēšanas un uzlabošanas apjoms.`)
};

/**
* | output |
* | --- |
* | "An agreed scope for maintenance and improvement." |
*
* @param {How_We_Work_Improve_Deliverable_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_improve_deliverable_value = /** @type {((inputs?: How_We_Work_Improve_Deliverable_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Improve_Deliverable_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_improve_deliverable_value(inputs)
	return en_how_we_work_improve_deliverable_value(inputs)
});